// @ts-nocheck
// datatable related plugins
import { yupResolver } from "@hookform/resolvers/yup";
import ConfirmModal from "components/shared-components/ConfirmModal";
import {
  MODE_INVOICE_ACTION,
  TYPE_ACTION_WORKFLOW,
} from "constants/IssueInvoiceConstant";
import { generateSelectField } from "helpers/form_helper_old";
import { checkIsHaveInvoicePos } from "helpers/utils";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import {
  actionWorkflowInvoicePos,
  actionWorkflowIssueInvoice,
  createInvoicePos,
  createIssueInvoice,
  createListProductInvoice,
  listInvoiceSymbol,
  resetActionWorkflowInvoicePos,
  resetActionWorkflowIssueInvoice,
  resetReplaceIssueInvoice,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  ACTION_WORKFLOW_INVOICE_POS_FAIL,
  ACTION_WORKFLOW_INVOICE_POS_SUCCESS,
  INVOICE_POS_CREATE_FAIL,
  INVOICE_POS_CREATE_SUCCESS,
  REPLACE_INVOICE_POS_FAIL,
  REPLACE_INVOICE_POS_SUCCESS,
} from "store/invoice-pos/actionTypes";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  ISSUE_INVOICE_CREATE_FAIL,
  ISSUE_INVOICE_CREATE_SUCCESS,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import * as yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DetailInvoicePos from "../InvoicePos/DetailInvoicePos";
import DetailInvoice from "./DetailInvoice";
import ConfirmActionInvoiceTT32 from "./modal/ConfirmActionInvoiceTT32";
import {
  KHHDON_LAST,
  KHMSHDON,
  getTypeWorkflowMessage,
  issueInvoiceModeList,
} from "./utils";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CreateInvoice = props => {
  const query = useQuery();
  const isPos = query.get("is-pos");

  const [listTypeHD, setListTypeHD] = useState([]);
  const [listTypeHDNormal, setListTypeHDNormal] = useState([]);
  const [listTypeHDPos, setListTypeHDPos] = useState([]);

  const HINH_THUC_HD = {
    HD_NORMAL: {
      value: "HD_NORMAL",
      label: "HĐĐT TT78",
    },
    HD_POS: {
      value: "HD_POS",
      label: "HĐ từ Máy tính tiền",
    },
  };
  const LIST_HINH_THUC_HD = [
    {
      value: HINH_THUC_HD.HD_NORMAL.value,
      label: HINH_THUC_HD.HD_NORMAL.label,
    },
    {
      value: HINH_THUC_HD.HD_POS.value,
      label: HINH_THUC_HD.HD_POS.label,
    },
  ];

  // isOpenAction32Modal
  const [isOpenAction32Modal, setIsOpenAction32Modal] = useState(false);
  const toggleOpenAction32Modal = () =>
    setIsOpenAction32Modal(!isOpenAction32Modal);

  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);

  const dispatch = useDispatch();

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const {
    errorList: errorInvoiceSymbolList,
    list: invoiceSymbolList,
    loadingList,
  } = invoiceSymbol;

  const [isUIRender, setIsUIRender] = useState(true);

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    buStoreHeader,
    tenantCodeHeader,
    buTenantHeaderInfo,
    finalBuInfo,
    listBuOfTenant,
  } = Dashboard;

  useEffect(() => {
    // K có quyền thì k dc vào menu MTT
    if (
      isPos &&
      buStoreHeader &&
      tenantCodeHeader &&
      !checkIsHaveInvoicePos(
        buTenantHeaderInfo,
        finalBuInfo,
        buStoreHeader,
        tenantCodeHeader,
        listBuOfTenant
      )
    ) {
      // history.push("/pages-404");
      setIsUIRender(false);
    } else {
      setIsUIRender(true);
    }
  }, [finalBuInfo, buStoreHeader, tenantCodeHeader, listBuOfTenant, isPos]);

  // store reducer
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { type, workflowInvoice, create, currentTime } = issueInvoice;

  const invoicePos = useSelector(state => state.invoicePos);
  const {
    type: typePos,
    workflowInvoice: workflowInvoicePos,
    create: createPos,
  } = invoicePos;

  const history = useHistory();
  const [detailModal, setDetailModal] = useState(false);

  const [isSelectType, setIsSelectType] = useState(false);

  const [isRoleStore, setIsRoleStore] = useState(false);

  useEffect(() => {
    switch (type) {
      case ISSUE_INVOICE_CREATE_SUCCESS:
        if (dataInvoiceTemp) {
          //GỬi duyệt hóa đơn
          toggleWorkflowModal();
          dispatch(
            actionWorkflowIssueInvoice(
              create.id,
              dataWorkflow.typeWorkFlow,
              null
            )
          );
        } else {
          // Tạo hóa đơn
          history.push("/invoice/new");
        }
        break;
      case ISSUE_INVOICE_CREATE_FAIL:
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS: {
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow) + " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        toggleWorkflowModal();
        history.push("/invoice/new");
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      }
      case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkFlow) + " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_SUCCESS:
        addToast(`Lập hóa đơn ${dataConfirmAction.infoTT32.text} thành công`, {
          appearance: "success",
          autoDismiss: true,
        });
        setDataConfirmAction(null);
        history.push("/invoice/new");
        dispatch(resetReplaceIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_FAIL:
        addToast(`Lập hóa đơn ${dataConfirmAction.infoTT32.text} thất bại`, {
          appearance: "error",
          autoDismiss: true,
        });
        setDataConfirmAction(null);
        dispatch(resetReplaceIssueInvoice());
        break;
    }
  }, [type]);

  useEffect(() => {
    switch (typePos) {
      case INVOICE_POS_CREATE_SUCCESS:
        if (dataInvoiceTemp) {
          //GỬi duyệt hóa đơn
          toggleWorkflowModal();
          dispatch(
            actionWorkflowInvoicePos(
              createPos.id,
              dataWorkflow.typeWorkFlow,
              null
            )
          );
        } else {
          // Tạo hóa đơn
          history.push("/invoice-pos/all");
        }
        break;
      case INVOICE_POS_CREATE_FAIL:
        break;
      case ACTION_WORKFLOW_INVOICE_POS_SUCCESS: {
        let mess =
          getTypeWorkflowMessage(workflowInvoicePos.typeWorkflow) +
          " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        toggleWorkflowModal();
        history.push("/invoice-pos/all");
        dispatch(resetActionWorkflowInvoicePos());
        break;
      }
      case ACTION_WORKFLOW_INVOICE_POS_FAIL:
        let mess =
          getTypeWorkflowMessage(workflowInvoicePos.typeWorkFlow) + " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowInvoicePos());
        break;
      case REPLACE_INVOICE_POS_SUCCESS:
        addToast(`Lập hóa đơn ${dataConfirmAction.infoTT32.text} thành công`, {
          appearance: "success",
          autoDismiss: true,
        });
        setDataConfirmAction(null);
        history.push("/invoice-pos/all");
        dispatch(resetReplaceInvoicePos());
        break;
      case REPLACE_INVOICE_POS_FAIL:
        addToast(`Lập hóa đơn ${dataConfirmAction.infoTT32.text} thất bại`, {
          appearance: "error",
          autoDismiss: true,
        });
        setDataConfirmAction(null);
        dispatch(resetReplaceInvoicePos());
        break;
    }
  }, [typePos]);

  useEffect(() => {
    if (invoiceSymbolList?.items && invoiceSymbolList?.items.length > 0) {
      const data = invoiceSymbolList?.items?.sort(
        (a, b) => b.is_default - a.is_default
      )?.[0];
      if (getValues("typeHD")) {
        const label =
          getValues("typeHD").ttchung_khmshdon +
          getValues("typeHD").khhdonDefault +
          data.khhdon;
        const value = getValues("typeHD").khhdonDefault + data.khhdon;
        setValue(
          "khhdon",
          {
            value,
            label,
          },
          {
            shouldValidate: true,
          }
        );
      }
    } else {
      setValue("khhdon", null);
    }
  }, [invoiceSymbolList]);

  useEffect(() => {
    if (finalBuInfo) {
      setIsSelectType(false);
      setValue("typeHD", {
        value: "",
        label: "",
      });
      setValue("khhdon", null);
      let listTypeHD = [];
      let curYear = currentTime?.data?.year.toString();
      curYear = curYear?.substr(curYear.length - 2);
      if (finalBuInfo) {
        if (finalBuInfo?.hdgtgt === 1) {
          listTypeHD.push({
            value: `PAGE_VAT_INVOICE_${
              finalBuInfo?.invoice_type === 1 ? "HAVE_CODE" : "NONE_CODE"
            }`,
            khhdonDefault: `${
              finalBuInfo?.invoice_type === 1 ? "C" : "K"
            }${curYear}${KHHDON_LAST.SALE}`,
            mode: issueInvoiceModeList.CREATE_VAT_INVOICE_DETAIL,
            ttchung_khmshdon: KHMSHDON.VAT,
            label: `HÓA ĐƠN ĐIỆN TỬ GIÁ TRỊ GIA TĂNG ${
              finalBuInfo?.invoice_type === 1 ? "(CÓ MÃ)" : "(KHÔNG MÃ)"
            }`,
          });
        }
        if (finalBuInfo?.hdbhang === 1) {
          listTypeHD.push({
            value: `PAGE_SALE_INVOICE_${
              finalBuInfo?.invoice_type === 1 ? "HAVE_CODE" : "NONE_CODE"
            }`,
            khhdonDefault: `${
              finalBuInfo?.invoice_type === 1 ? "C" : "K"
            }${curYear}${KHHDON_LAST.SALE}`,
            mode: issueInvoiceModeList.CREATE_SALE_INVOICE_DETAIL,
            ttchung_khmshdon: KHMSHDON.SALE,
            label: `HÓA ĐƠN ĐIỆN TỬ BÁN HÀNG ${
              finalBuInfo?.invoice_type === 1 ? "(CÓ MÃ)" : "(KHÔNG MÃ)"
            }`,
          });
        }
        setValue(
          "hinhthucHD",
          isPos ? LIST_HINH_THUC_HD[1] : LIST_HINH_THUC_HD[0]
        );
        const listTypeHDPos = listTypeHD.map(item => {
          return {
            ...item,
            khhdonDefault: `${
              finalBuInfo?.invoice_type === 1 ? "C" : "K"
            }${curYear}${KHHDON_LAST.POS}`,
          };
        });
        setListTypeHD(isPos ? listTypeHDPos : listTypeHD);
        setListTypeHDNormal(listTypeHD);
        setListTypeHDPos(listTypeHDPos);
      }
    }
  }, [finalBuInfo]);

  // Action Dispatch
  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
  }, []);

  const actionReplaceOrAdjustInvoice = data => {
    const finalDataConfirm = {
      ...data,
      ...dataConfirmAction,
      mode: MODE_INVOICE_ACTION.REPLACE, // Lun hiểu ở Mức thay thế vì k có hóa đơn cha để điều chỉnh
      typeAdjust: data.infoTT32.typeAdjust,
    };
    setDataConfirmAction(finalDataConfirm);
    toggleDetailModal();
  };

  const { addToast } = useToasts();

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);

  const schema = yup.object().shape({
    hinhthucHD: yup.object().required("Vui lòng chọn hình thức hóa đơn"),
    typeHD: yup.object().required("Vui lòng  chọn loại hóa đơn"),
    khhdon: yup.object().required("Vui lòng  chọn ký hiệu hóa đơn").nullable(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      hinhthucHD: isPos ? LIST_HINH_THUC_HD[1] : LIST_HINH_THUC_HD[0],
      typeHD: undefined,
      khhdon: undefined,
    },
  });

  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkFlow: null,
    titleModal: null,
    bodyModal: null,
  });

  // finalData: null,
  // typeAnother: null,
  // listProduct: [],
  const [dataInvoiceTemp, setDataInvoiceTemp] = useState(null);

  const [btnShowFooter, setBtnShowFooter] = useState({
    btnRelease: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
    btnSubmit: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
  });

  const onSubmit = values => {
    setDataConfirmAction(null);
    toggleDetailModal();
    generateButtonWhenCreate();
  };

  const onSubmitActionTT32 = () => {
    setBtnShowFooter({
      btnRelease: {
        isShow: false,
        onClick: null,
      },
      btnSubmit: {
        isShow: false,
        onClick: null,
      },
    });
    toggleConfirmActionModal();
  };

  const generateButtonWhenCreate = () => {
    setBtnShowFooter({
      btnRelease: {
        isShow: finalBuInfo?.need_approve === 0,
        onClick: null,
      },
      btnSubmit: {
        isShow: finalBuInfo?.need_approve === 1 && isRoleStore,
        onClick: null,
        toggleModal: () => {
          setDataWorkflow({
            typeWorkFlow: TYPE_ACTION_WORKFLOW.SUBMIT,
            titleModal: "Xác nhận gửi duyệt hóa đơn",
            bodyModal: "Hệ thống sẽ gửi duyệt hóa đơn này",
          });
          toggleWorkflowModal();
        },
      },
    });
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };

  const fetchListInvoiceSymbol = hinhthucHDValue => {
    const buTenant = localStorage.getItem("BU_STORE_HEADER");
    // Get list ký hiệu hóa đơn ( 2 ký tự cuối)
    invoiceSymbolList.params.page = -1;
    invoiceSymbolList.params.sort = "name";
    invoiceSymbolList.params.columnFilter = {
      "filter[record_status]": "O",
      "filter[is_pos]":
        hinhthucHDValue === HINH_THUC_HD.HD_NORMAL.value ? 0 : 1,
      "filter[bu_code]": buTenant,
      "filter[khmhdon]":
        getValues("typeHD") && getValues("typeHD").ttchung_khmshdon,
    };
    invoiceSymbolList.params.fields = "";
    dispatch(listInvoiceSymbol(invoiceSymbolList.params, true));
  };

  return (
    <React.Fragment>
      {/* WORKFLOW modal */}
      <ConfirmModal
        isOpen={modalWorkflow}
        titleHeader={dataWorkflow.titleModal}
        titleBody={dataWorkflow.bodyModal}
        isDisableButton={workflowInvoice.loading}
        isHaveNote={dataWorkflow.typeWorkFlow === TYPE_ACTION_WORKFLOW.REJECT}
        onConfirm={note => {
          dispatch(createListProductInvoice(dataInvoiceTemp.listProduct));
          if (dataInvoiceTemp?.isInvoicePos) {
            dispatch(
              createInvoicePos(
                dataInvoiceTemp.finalData,
                dataInvoiceTemp.typeAnother
              )
            );
          } else {
            dispatch(
              createIssueInvoice(
                dataInvoiceTemp.finalData,
                dataInvoiceTemp.typeAnother
              )
            );
          }
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleWorkflowModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>Lập hóa đơn</title>
        </MetaTags>
        <div className="container-fluid">
          <ConfirmActionInvoiceTT32
            confirmActionData={dataConfirmAction}
            isOpen={modalConfirmAction}
            toggle={toggleConfirmActionModal}
            actionReplaceOrAdjustInvoice={actionReplaceOrAdjustInvoice}
          />
          <Breadcrumbs title="" breadcrumbItem={"Lập hóa đơn"} />
          {isUIRender ? (
            <Card>
              <CardBody style={{ minHeight: "450px" }}>
                <Row className="row-cols-1 row-cols-md-4 ">
                  {/* Loại Hóa Đơn */}
                  <Col style={{ width: "201px" }}>
                    {generateSelectField(
                      "Hình thức Hóa Đơn",
                      true,
                      errors,
                      "hinhthucHD",
                      "Vui lòng chọn",
                      false,
                      control,
                      checkIsHaveInvoicePos(buTenantHeaderInfo, finalBuInfo)
                        ? LIST_HINH_THUC_HD
                        : [LIST_HINH_THUC_HD[0]],
                      "auto",
                      select => {
                        const hinhthucHDValue = select?.value;
                        switch (hinhthucHDValue) {
                          case HINH_THUC_HD.HD_NORMAL.value:
                            setListTypeHD(listTypeHDNormal);
                            setValue("typeHD", listTypeHDNormal[0]);
                            break;
                          case HINH_THUC_HD.HD_POS.value:
                            setListTypeHD(listTypeHDPos);
                            setValue("typeHD", listTypeHDPos[0]);
                            break;
                          default:
                            break;
                        }
                        fetchListInvoiceSymbol(hinhthucHDValue);
                      },
                      false
                    )}
                  </Col>
                  {/* Loại Hóa Đơn */}
                  <Col style={{}}>
                    {generateSelectField(
                      "Loại Hóa Đơn",
                      true,
                      errors,
                      "typeHD",
                      "Vui lòng chọn",
                      false,
                      control,
                      listTypeHD,
                      "auto",
                      () => {
                        setIsSelectType(true);
                        fetchListInvoiceSymbol(getValues("hinhthucHD")?.value);
                      },
                      false
                    )}
                    {listTypeHD.length > 0 ? (
                      <span
                        style={{ fontStyle: "italic" }}
                        className="text-primary font-size-15 mt-2"
                      >
                        *Chọn loại hóa đơn và ký hiệu hóa đơn muốn lập
                      </span>
                    ) : (
                      <span
                        style={{ fontStyle: "italic" }}
                        className="text-danger font-size-15 mt-2"
                      >
                        *Chưa được phép lập hóa đơn. Vui lòng tạo tờ khai đăng
                        ký sử dụng hóa đơn
                      </span>
                    )}
                  </Col>
                  {/* Ký hiệu hóa đơn */}
                  <Col style={{ width: "200px" }}>
                    {generateSelectField(
                      "Ký hiệu hóa đơn",
                      true,
                      errors,
                      "khhdon",
                      "Vui lòng chọn",
                      false,
                      control,
                      getValues("typeHD") &&
                        getValues("typeHD").ttchung_khmshdon
                        ? invoiceSymbolList?.items.map(item => {
                            const label =
                              getValues("typeHD").ttchung_khmshdon +
                              getValues("typeHD").khhdonDefault +
                              item.khhdon;
                            const value =
                              getValues("typeHD").khhdonDefault + item.khhdon;
                            return {
                              value: value,
                              label: label,
                            };
                          })
                        : [],
                      "auto",
                      () => {},
                      false
                    )}
                  </Col>
                  <Col style={{ marginTop: "28px", width: "171px" }}>
                    <Button
                      type="button"
                      color="primary"
                      className="me-2 btn-label"
                      disabled={loadingList}
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                    >
                      <i className="bx bx-receipt label-icon" />
                      Lập hóa đơn
                    </Button>
                  </Col>
                  <Col style={{ marginTop: "28px" }}>
                    <ButtonDropdown
                      className="me-2"
                      isOpen={isOpenAction32Modal}
                      disabled={loadingList || !isSelectType}
                      toggle={toggleOpenAction32Modal}
                    >
                      <DropdownToggle
                        className="btn-label"
                        caret
                        color="info"
                        outline
                      >
                        <i className="bx bx-message-square-check label-icon" />
                        Nghiệp vụ với hóa đơn TT32
                        <i
                          style={{ marginLeft: "5px" }}
                          className="mdi mdi-chevron-down"
                        />
                      </DropdownToggle>
                      <DropdownMenu
                        style={{ zIndex: 3, border: " 1px solid #808080d4" }}
                      >
                        <div style={{ color: "white" }}>
                          <DropdownItem
                            style={{ position: "relative" }}
                            className="d-flex gap-1 align-items-center"
                            onClick={() => {
                              setDataConfirmAction({
                                mode: MODE_INVOICE_ACTION.REPLACE,
                              });
                              handleSubmit(onSubmitActionTT32)();
                            }}
                          >
                            <i className="bx bx-rotate-left font-size-18 text-primary" />
                            <span>Thay thế hóa đơn TT32</span>
                          </DropdownItem>{" "}
                          {/* <DropdownItem
                          style={{ position: "relative" }}
                          className="d-flex gap-1 align-items-center"
                          onClick={() => {
                            setDataConfirmAction({
                              mode: MODE_INVOICE_ACTION.ADJUST,
                            });
                            handleSubmit(onSubmitActionTT32)();
                          }}
                        >
                          <i className="bx bx-edit font-size-18 text-primary" />
                          <span>Điều chỉnh hóa đơn TT32</span>
                        </DropdownItem>{" "} */}
                        </div>
                      </DropdownMenu>
                    </ButtonDropdown>
                  </Col>
                </Row>
                {getValues("hinhthucHD")?.value ===
                  HINH_THUC_HD.HD_NORMAL.value && (
                  <DetailInvoice
                    dataConfirmAction={dataConfirmAction}
                    isOpenModal={detailModal}
                    btnShowFooter={btnShowFooter}
                    toggleModal={toggleDetailModal}
                    khhdonDefault={
                      getValues("khhdon") && getValues("khhdon").value
                    }
                    mode={getValues("typeHD") && getValues("typeHD").mode}
                    pageView={getValues("typeHD") && getValues("typeHD").value}
                    invoiceSymbolList={invoiceSymbolList.items}
                    setDataInvoiceTemp={setDataInvoiceTemp}
                  />
                )}
                {getValues("hinhthucHD")?.value ===
                  HINH_THUC_HD.HD_POS.value && (
                  <DetailInvoicePos
                    dataConfirmAction={dataConfirmAction}
                    isOpenModal={detailModal}
                    btnShowFooter={btnShowFooter}
                    toggleModal={toggleDetailModal}
                    khhdonDefault={
                      getValues("khhdon") && getValues("khhdon").value
                    }
                    mode={getValues("typeHD") && getValues("typeHD").mode}
                    pageView={getValues("typeHD") && getValues("typeHD").value}
                    invoiceSymbolList={invoiceSymbolList.items}
                    setDataInvoiceTemp={setDataInvoiceTemp}
                  />
                )}
              </CardBody>
            </Card>
          ) : (
            <div className="text-center text-danger font-size-20 font-weight-bold">
              Vui lòng chọn chi nhánh/đơn vị có cấu hình HĐ từ MTT
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateInvoice;
